/* file description */

import { useState } from 'react';
import type { UseUploadWrap } from './type';

export const useUploadWrap: UseUploadWrap = () => {
  const [uploadWrapVisible, setUploadWrap] = useState<boolean>(false);
  const [importVisible, setImportVisible] = useState<boolean>(false);
  const [previewProps, setPreviewProps] = useState<Record<any, any>>({ visible: false, previewUrl: '', fileType: '' });
  const [exportVisible, setExportVisible] = useState<boolean>(false);
  return {
    uploadWrapVisible,
    setUploadWrap,
    importVisible,
    setImportVisible,
    previewProps,
    setPreviewProps,
    exportVisible,
    setExportVisible,
  };
};
